// // // import React, { useState, useEffect } from "react";
// // // import styles from "./category.module.css";
// // // import { categoryApi } from "../../../api/home/categoryApi";
// // // import {
// // //   Chart as ChartJS,
// // //   CategoryScale,
// // //   LinearScale,
// // //   BarElement,
// // //   Title,
// // //   Tooltip,
// // //   Legend
// // // } from 'chart.js';
// // // import { Bar } from 'react-chartjs-2';

// // // ChartJS.register(
// // //   CategoryScale,
// // //   LinearScale,
// // //   BarElement,
// // //   Title,
// // //   Tooltip,
// // //   Legend
// // // );

// // // const Category = () => {
// // //   const [financialYear, setFinancialYear] = useState('');
// // //   const [chartData, setChartData] = useState(null);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState(null);

// // //   // Category colors - using provided color scheme
// // //   const categoryColors = {
// // //     "3A Chemicals": "#4E79A7",
// // //     "Amino Acids": "#F28E2B",
// // //     "Analytical Instruments": "#E15759",
// // //     "Analytical Standards": "#76B7B2",
// // //     "API": "#59A14F",
// // //     "Assets": "#EDC948",
// // //     "Biochemicals": "#B07AA1",
// // //     "Biological Buffers": "#FF9DA7",
// // //     "British Pharmacopoeia": "#9C755F",
// // //     "Building Blocks": "#BAB0AC",
// // //     "Cans": "#17BECF",
// // //     "Capricorn": "#BCBD22",
// // //     "Carbohydrates": "#393B79",
// // //     "Catalyst": "#5254A3",
// // //     "Cell Culture": "#6B6ECF",
// // //     "Chinese Pharmacopeia": "#4E79A7",
// // //     "Cylinders": "#9C9EDE",
// // //     "Dyes": "#637939",
// // //     "Enzyme": "#8CA252",
// // //     "EP Standards": "#B5CF6B",
// // //     "Equipment and Instruments": "#CEDB9C",
// // //     "Fine Chemicals": "#8C6D31",
// // //     "Fixed Assets": "#BD9E39",
// // //     "Food Grade": "#BD9E39",
// // //     "Gas Chromatography": "#E7BA52",
// // //     "GC Consumable": "#843C39",
// // //     "Glucuronides": "#E7BA52",
// // //     "High Purity Acids": "#843C39",
// // //     "HPLC configurations": "#AD494A",
// // //     "HPLC consumables": "#D6616B",
// // //     "Impurity": "#AD494A",
// // //     "Indian pharmacopoeia": "#D6616B",
// // //     "Instruments": "#E7969C",
// // //     "Intermediates": "#7B4173",
// // //     "Items": "#A55194",
// // //     "Kanto": "#CE6DBD",
// // //     "Lab Consumables": "#CE6DBD",
// // //     "Lab Systems & Fixtures": "#DE9ED6",
// // //     "Label": "#3182BD",
// // //     "Laboratory Containers & Storage": "#3182BD",
// // //     "Life science": "#6BAED6",
// // //     "Ligand": "#9ECAE1",
// // //     "Meatls&materials": "#E6550D",
// // //     "Membranes": "#6BAED6",
// // //     "Metabolites": "#9ECAE1",
// // //     "Metal Standard Solutions": "#E6550D",
// // //     "Multiple Pharmacopoeia": "#FD8D3C",
// // //     "Natural Products": "#FDAE6B",
// // //     "New Life Biologics": "#FDD0A2",
// // //     "Nitrosamine": "#31A354",
// // //     "NMR Solvents": "#74C476",
// // //     "Nucleosides and Nucleotides": "#A1D99B",
// // //     "Packaging Materials": "#C7E9C0",
// // //     "Peptides": "#756BB1",
// // //     "Pesticide Standards": "#9E9AC8",
// // //     "Polymer": "#BCBDDC",
// // //     "Reagent": "#DADAEB",
// // //     "Reference Materials": "#636363",
// // //     "Secondary Standards": "#969696",
// // //     "Services": "#BDBDBD",
// // //     "Solvent": "#D9D9D9",
// // //     "Stable Isotope reagents": "#8DD3C7",
// // //     "Stable isotopes": "#FFFFB3",
// // //     "Sustaintech": "#BEBADA",
// // //     "Trading": "#BEBADA",
// // //     "Ultrapur": "#FB8072",
// // //     "Ultrapur-100": "#80B1D3",
// // //     "USP Standards": "#FDB462",
// // //     "VOLAB": "#FD8D3C",
// // //     "Uncategorized": "#9ca3af"
// // //   };

// // //   // Calculate current financial year
// // //   useEffect(() => {
// // //     const today = new Date();
// // //     const currentMonth = today.getMonth() + 1;
// // //     const currentYear = today.getFullYear();
    
// // //     const fyStart = currentMonth >= 4 ? currentYear : currentYear - 1;
// // //     const fyEnd = fyStart + 1;
    
// // //     setFinancialYear(`${fyStart}-${fyEnd.toString().slice(2)}`);
// // //   }, []);

// // //   useEffect(() => {
// // //     if (financialYear) {
// // //       fetchCategoryData();
// // //     }
// // //   }, [financialYear]);

// // //   const fetchCategoryData = async () => {
// // //     try {
// // //       setLoading(true);
// // //       setError(null);
      
// // //       console.log('📊 Fetching category data for FY:', financialYear);
      
// // //       const data = await categoryApi.getCategoryData(financialYear);
      
// // //       console.log('✅ Category data received:', data);
      
// // //       prepareChartData(data);
// // //     } catch (err) {
// // //       setError('Failed to load category data');
// // //       console.error('❌ Error fetching category data:', err);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const prepareChartData = (data) => {
// // //     if (!data || data.length === 0) {
// // //       setChartData(null);
// // //       return;
// // //     }

// // //     // Get unique months
// // //     const months = [...new Set(data.map(item => item.month))];
    
// // //     // Get unique categories with sales > 0
// // //     const categories = [...new Set(data.map(item => item.category))]
// // //       .filter(category => {
// // //         const totalSales = data
// // //           .filter(d => d.category === category)
// // //           .reduce((sum, d) => sum + (d.sales || 0), 0);
// // //         return totalSales > 0;
// // //       });

// // //     // Create datasets for each category
// // //     const datasets = categories.map(category => {
// // //       const categoryData = months.map(month => {
// // //         const found = data.find(d => d.month === month && d.category === category);
// // //         return found ? found.sales : 0;
// // //       });

// // //       // Store additional data for tooltip
// // //       const linesData = months.map(month => {
// // //         const found = data.find(d => d.month === month && d.category === category);
// // //         return found ? found.lines : 0;
// // //       });

// // //       const quantityData = months.map(month => {
// // //         const found = data.find(d => d.month === month && d.category === category);
// // //         return found ? found.quantity : 0;
// // //       });

// // //       return {
// // //         label: category,
// // //         data: categoryData,
// // //         linesData: linesData,
// // //         quantityData: quantityData,
// // //         backgroundColor: categoryColors[category] || '#9ca3af',
// // //         borderColor: categoryColors[category] || '#9ca3af',
// // //         borderWidth: 1
// // //       };
// // //     });

// // //     const chartConfig = {
// // //       labels: months,
// // //       datasets: datasets
// // //     };

// // //     setChartData(chartConfig);
// // //   };

// // //   const chartOptions = {
// // //     responsive: true,
// // //     maintainAspectRatio: false,
// // //     plugins: {
// // //       legend: {
// // //         display: false // Hide the legend
// // //       },
// // //       tooltip: {
// // //         callbacks: {
// // //           title: function(context) {
// // //             return context[0].label;
// // //           },
// // //           beforeBody: function(context) {
// // //             // Calculate total for this month
// // //             let total = 0;
// // //             context.forEach(item => {
// // //               total += item.parsed.y;
// // //             });
            
// // //             const formattedTotal = '₹' + total.toLocaleString('en-IN', {
// // //               minimumFractionDigits: 0,
// // //               maximumFractionDigits: 0
// // //             });
            
// // //             return 'Total Sales: ' + formattedTotal;
// // //           },
// // //           label: function(context) {
// // //             // Calculate total for percentage
// // //             let total = 0;
// // //             const dataIndex = context.dataIndex;
// // //             context.chart.data.datasets.forEach(dataset => {
// // //               total += dataset.data[dataIndex] || 0;
// // //             });
            
// // //             const category = context.dataset.label;
// // //             const sales = context.parsed.y;
// // //             const percentage = total > 0 ? ((sales / total) * 100).toFixed(2) : 0;
            
// // //             const formattedSales = '₹' + (sales || 0).toLocaleString('en-IN', {
// // //               minimumFractionDigits: 0,
// // //               maximumFractionDigits: 0
// // //             });
            
// // //             return category + ': ' + formattedSales + ' (' + percentage + '%)';
// // //           },
// // //           footer: function() {
// // //             return ''; // Remove footer
// // //           }
// // //         },
// // //         // Filter out categories with 0 sales
// // //         filter: function(tooltipItem) {
// // //           return tooltipItem.parsed.y > 0;
// // //         },
// // //         // Show all categories when hovering
// // //         mode: 'index',
// // //         intersect: false
// // //       }
// // //     },
// // //     scales: {
// // //       x: {
// // //         stacked: true,
// // //         grid: {
// // //           display: false
// // //         },
// // //         title: {
// // //           display: true,
// // //           text: 'Month',
// // //           font: {
// // //             size: 12,
// // //             weight: 'bold'
// // //           }
// // //         }
// // //       },
// // //       y: {
// // //         stacked: true,
// // //         beginAtZero: true,
// // //         grid: {
// // //           color: '#e5e7eb'
// // //         },
// // //         title: {
// // //           display: true,
// // //           text: 'Sales Amount (₹)',
// // //           font: {
// // //             size: 12,
// // //             weight: 'bold'
// // //           }
// // //         },
// // //         ticks: {
// // //           callback: function(value) {
// // //             if (value >= 10000000) {
// // //               return '₹' + (value / 10000000).toFixed(1) + 'Cr';
// // //             } else if (value >= 100000) {
// // //               return '₹' + (value / 100000).toFixed(1) + 'L';
// // //             } else if (value >= 1000) {
// // //               return '₹' + (value / 1000).toFixed(0) + 'K';
// // //             }
// // //             return '₹' + value;
// // //           }
// // //         }
// // //       }
// // //     },
// // //     interaction: {
// // //       mode: 'index',
// // //       intersect: false
// // //     }
// // //   };

// // //   return (
// // //     <div className={styles.componentWrapper}>
// // //       <div className={styles.headerSection}>
// // //         <h2 className={styles.componentTitle}>Category-wise Sales</h2>
        
// // //         <div className={styles.fyDropdown}>
// // //           <label>FY:</label>
// // //           <select 
// // //             value={financialYear} 
// // //             onChange={(e) => setFinancialYear(e.target.value)}
// // //             className={styles.select}
// // //           >
// // //             <option value="2025-26">2025-26</option>
// // //             <option value="2024-25">2024-25</option>
// // //             <option value="2023-24">2023-24</option>
// // //           </select>
// // //         </div>
// // //       </div>

// // //       {error && (
// // //         <div className={styles.errorMessage}>{error}</div>
// // //       )}

// // //       {loading && (
// // //         <div className={styles.loadingContainer}>
// // //           <div className={styles.loadingSpinner} />
// // //           <span>Loading chart data...</span>
// // //         </div>
// // //       )}

// // //       {!loading && chartData && (
// // //         <div className={styles.chartContainer}>
// // //           <Bar data={chartData} options={chartOptions} />
// // //         </div>
// // //       )}

// // //       {!loading && !chartData && !error && (
// // //         <div className={styles.noDataMessage}>
// // //           No category data available for FY {financialYear}
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default Category;


// // import React, { useState, useEffect, useCallback } from "react";
// // import styles from "./category.module.css";
// // import { categoryApi } from "../../../api/home/categoryApi";
// // import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
// // import {
// //     Chart as ChartJS,
// //     CategoryScale,
// //     LinearScale,
// //     BarElement,
// //     Title,
// //     Tooltip,
// //     Legend
// // } from 'chart.js';
// // import { Bar } from 'react-chartjs-2';

// // ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // // ─── Same FY helpers as SalesVsCogs ───────────────────────────────────────
// // const getCurrentFY = () => {
// //     const now = new Date();
// //     const month = now.getMonth() + 1;
// //     const year = now.getFullYear();
// //     const startYear = month >= 4 ? year : year - 1;
// //     return `${startYear}-${String(startYear + 1).slice(2)}`;
// // };

// // const buildFYOptions = () => {
// //     const current = new Date().getFullYear();
// //     const options = [];
// //     for (let y = current; y >= 2022; y--) {
// //         options.push(`${y}-${String(y + 1).slice(2)}`);
// //     }
// //     return options;
// // };

// // const categoryColors = {
// //     "3A Chemicals": "#4E79A7",
// //     "Amino Acids": "#F28E2B",
// //     "Analytical Instruments": "#E15759",
// //     "Analytical Standards": "#76B7B2",
// //     "API": "#59A14F",
// //     "Assets": "#EDC948",
// //     "Biochemicals": "#B07AA1",
// //     "Biological Buffers": "#FF9DA7",
// //     "British Pharmacopoeia": "#9C755F",
// //     "Building Blocks": "#BAB0AC",
// //     "Cans": "#17BECF",
// //     "Capricorn": "#BCBD22",
// //     "Carbohydrates": "#393B79",
// //     "Catalyst": "#5254A3",
// //     "Cell Culture": "#6B6ECF",
// //     "Chinese Pharmacopeia": "#4E79A7",
// //     "Cylinders": "#9C9EDE",
// //     "Dyes": "#637939",
// //     "Enzyme": "#8CA252",
// //     "EP Standards": "#B5CF6B",
// //     "Equipment and Instruments": "#CEDB9C",
// //     "Fine Chemicals": "#8C6D31",
// //     "Fixed Assets": "#BD9E39",
// //     "Food Grade": "#BD9E39",
// //     "Gas Chromatography": "#E7BA52",
// //     "GC Consumable": "#843C39",
// //     "Glucuronides": "#E7BA52",
// //     "High Purity Acids": "#843C39",
// //     "HPLC configurations": "#AD494A",
// //     "HPLC consumables": "#D6616B",
// //     "Impurity": "#AD494A",
// //     "Indian pharmacopoeia": "#D6616B",
// //     "Instruments": "#E7969C",
// //     "Intermediates": "#7B4173",
// //     "Items": "#A55194",
// //     "Kanto": "#CE6DBD",
// //     "Lab Consumables": "#CE6DBD",
// //     "Lab Systems & Fixtures": "#DE9ED6",
// //     "Label": "#3182BD",
// //     "Laboratory Containers & Storage": "#3182BD",
// //     "Life science": "#6BAED6",
// //     "Ligand": "#9ECAE1",
// //     "Meatls&materials": "#E6550D",
// //     "Membranes": "#6BAED6",
// //     "Metabolites": "#9ECAE1",
// //     "Metal Standard Solutions": "#E6550D",
// //     "Multiple Pharmacopoeia": "#FD8D3C",
// //     "Natural Products": "#FDAE6B",
// //     "New Life Biologics": "#FDD0A2",
// //     "Nitrosamine": "#31A354",
// //     "NMR Solvents": "#74C476",
// //     "Nucleosides and Nucleotides": "#A1D99B",
// //     "Packaging Materials": "#C7E9C0",
// //     "Peptides": "#756BB1",
// //     "Pesticide Standards": "#9E9AC8",
// //     "Polymer": "#BCBDDC",
// //     "Reagent": "#DADAEB",
// //     "Reference Materials": "#636363",
// //     "Secondary Standards": "#969696",
// //     "Services": "#BDBDBD",
// //     "Solvent": "#D9D9D9",
// //     "Stable Isotope reagents": "#8DD3C7",
// //     "Stable isotopes": "#FFFFB3",
// //     "Sustaintech": "#BEBADA",
// //     "Trading": "#BEBADA",
// //     "Ultrapur": "#FB8072",
// //     "Ultrapur-100": "#80B1D3",
// //     "USP Standards": "#FDB462",
// //     "VOLAB": "#FD8D3C",
// //     "Uncategorized": "#9ca3af"
// // };

// // const Category = () => {
// //     const fyOptions = buildFYOptions();
// //     const [financialYear, setFinancialYear] = useState(getCurrentFY());
// //     const [activeFilters, setActiveFilters]  = useState({});
// //     const [chartData, setChartData]          = useState(null);
// //     const [userRole, setUserRole]            = useState(null);
// //     const [loading, setLoading]              = useState(false);
// //     const [error, setError]                  = useState(null);

// //     // ─── Fetch ─────────────────────────────────────────────────
// //     const fetchCategoryData = async () => {
// //         try {
// //             setLoading(true);
// //             setError(null);

// //             // Take first value from comma-separated multi-select (same as SalesVsCogs)
// //             const filtersToSend = {};
// //             Object.entries(activeFilters).forEach(([key, val]) => {
// //                 if (val) {
// //                     const first = val.split(',')[0];
// //                     if (first) filtersToSend[key] = first;
// //                 }
// //             });

// //             const response = await categoryApi.getCategoryData(financialYear, filtersToSend);
// //             const data     = response?.data || response;
// //             const roleId   = response?.roleId;

// //             setUserRole(roleId);
// //             prepareChartData(data);
// //         } catch (err) {
// //             setError('Failed to load category data');
// //             console.error('❌ Error:', err);
// //         } finally {
// //             setLoading(false);
// //         }
// //     };

// //     useEffect(() => { fetchCategoryData(); }, [financialYear, activeFilters]);

// //     // ─── Chart preparation ──────────────────────────────────────
// //     const prepareChartData = (data) => {
// //         if (!data || data.length === 0) { setChartData(null); return; }

// //         const months = [...new Set(data.map(item => item.month))];

// //         const categories = [...new Set(data.map(item => item.category))]
// //             .filter(category => {
// //                 const totalSales = data
// //                     .filter(d => d.category === category)
// //                     .reduce((sum, d) => sum + (d.sales || 0), 0);
// //                 return totalSales > 0;
// //             });

// //         const datasets = categories.map(category => {
// //             const categoryData = months.map(month => {
// //                 const found = data.find(d => d.month === month && d.category === category);
// //                 return found ? found.sales : 0;
// //             });

// //             const linesData = months.map(month => {
// //                 const found = data.find(d => d.month === month && d.category === category);
// //                 return found ? found.lines : 0;
// //             });

// //             const quantityData = months.map(month => {
// //                 const found = data.find(d => d.month === month && d.category === category);
// //                 return found ? found.quantity : 0;
// //             });

// //             return {
// //                 label: category,
// //                 data: categoryData,
// //                 linesData,
// //                 quantityData,
// //                 backgroundColor: categoryColors[category] || '#9ca3af',
// //                 borderColor: categoryColors[category] || '#9ca3af',
// //                 borderWidth: 1
// //             };
// //         });

// //         setChartData({ labels: months, datasets });
// //     };

// //     // ─── Stable filter callback ────────────────────────────────
// //     const handleFiltersChange = useCallback((newFilters) => {
// //         setActiveFilters(newFilters);
// //     }, []);

// //     const chartOptions = {
// //         responsive: true,
// //         maintainAspectRatio: false,
// //         plugins: {
// //             legend: { display: false },
// //             tooltip: {
// //                 callbacks: {
// //                     title: (context) => context[0].label,
// //                     beforeBody: (context) => {
// //                         let total = 0;
// //                         context.forEach(item => { total += item.parsed.y; });
// //                         return 'Total Sales: ₹' + total.toLocaleString('en-IN', {
// //                             minimumFractionDigits: 0, maximumFractionDigits: 0
// //                         });
// //                     },
// //                     label: (context) => {
// //                         let total = 0;
// //                         const dataIndex = context.dataIndex;
// //                         context.chart.data.datasets.forEach(dataset => {
// //                             total += dataset.data[dataIndex] || 0;
// //                         });
// //                         const sales = context.parsed.y;
// //                         const percentage = total > 0 ? ((sales / total) * 100).toFixed(2) : 0;
// //                         const formattedSales = '₹' + (sales || 0).toLocaleString('en-IN', {
// //                             minimumFractionDigits: 0, maximumFractionDigits: 0
// //                         });
// //                         return context.dataset.label + ': ' + formattedSales + ' (' + percentage + '%)';
// //                     },
// //                     footer: () => ''
// //                 },
// //                 filter: (tooltipItem) => tooltipItem.parsed.y > 0,
// //                 mode: 'index',
// //                 intersect: false
// //             }
// //         },
// //         scales: {
// //             x: {
// //                 stacked: true,
// //                 grid: { display: false },
// //                 title: { display: true, text: 'Month', font: { size: 12, weight: 'bold' } }
// //             },
// //             y: {
// //                 stacked: true,
// //                 beginAtZero: true,
// //                 grid: { color: '#e5e7eb' },
// //                 title: { display: true, text: 'Sales Amount (₹)', font: { size: 12, weight: 'bold' } },
// //                 ticks: {
// //                     callback: (value) => {
// //                         if (value >= 10000000) return '₹' + (value / 10000000).toFixed(1) + 'Cr';
// //                         if (value >= 100000) return '₹' + (value / 100000).toFixed(1) + 'L';
// //                         if (value >= 1000) return '₹' + (value / 1000).toFixed(0) + 'K';
// //                         return '₹' + value;
// //                     }
// //                 }
// //             }
// //         },
// //         interaction: { mode: 'index', intersect: false }
// //     };

// //     return (
// //         <div className={styles.componentWrapper}>
// //             <div className={styles.headerSection}>
// //                 <h2 className={styles.componentTitle}>Category-wise Sales</h2>
// //                 <div className={styles.fyDropdown}>
// //                     <label>FY:</label>
// //                     <select
// //                         value={financialYear}
// //                         onChange={(e) => setFinancialYear(e.target.value)}
// //                         className={styles.select}
// //                     >
// //                         {fyOptions.map(fy => (
// //                             <option key={fy} value={fy}>{fy}</option>
// //                         ))}
// //                     </select>
// //                 </div>
// //             </div>

// //             {/* Same filters as SalesVsCogs */}
// //             <SalesCogsFilters
// //                 userRoleId={userRole}
// //                 onFiltersChange={handleFiltersChange}
// //             />

// //             {error && <div className={styles.errorMessage}>{error}</div>}

// //             {loading && (
// //                 <div className={styles.loadingContainer}>
// //                     <div className={styles.loadingSpinner} />
// //                     <span>Loading chart data...</span>
// //                 </div>
// //             )}

// //             {!loading && chartData && (
// //                 <div className={styles.chartContainer}>
// //                     <Bar data={chartData} options={chartOptions} />
// //                 </div>
// //             )}

// //             {!loading && !chartData && !error && (
// //                 <div className={styles.noDataMessage}>
// //                     No category data available for FY {financialYear}
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };

// // export default Category;

// import React, { useState, useEffect, useCallback } from "react";
// import styles from "./category.module.css";
// import { categoryApi } from "../../../api/home/categoryApi";
// import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     Title,
//     Tooltip,
//     Legend
// } from 'chart.js';
// import { Bar } from 'react-chartjs-2';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// // ─── Same FY helpers as SalesVsCogs ───────────────────────────────────────
// const getCurrentFY = () => {
//     const now = new Date();
//     const month = now.getMonth() + 1;
//     const year = now.getFullYear();
//     const startYear = month >= 4 ? year : year - 1;
//     return `${startYear}-${String(startYear + 1).slice(2)}`;
// };

// const buildFYOptions = () => {
//     const current = new Date().getFullYear();
//     const options = [];
//     for (let y = current; y >= 2022; y--) {
//         options.push(`${y}-${String(y + 1).slice(2)}`);
//     }
//     return options;
// };

// const categoryColors = {
//     "3A Chemicals": "#4E79A7",
//     "Amino Acids": "#F28E2B",
//     "Analytical Instruments": "#E15759",
//     "Analytical Standards": "#76B7B2",
//     "API": "#59A14F",
//     "Assets": "#EDC948",
//     "Biochemicals": "#B07AA1",
//     "Biological Buffers": "#FF9DA7",
//     "British Pharmacopoeia": "#9C755F",
//     "Building Blocks": "#BAB0AC",
//     "Cans": "#17BECF",
//     "Capricorn": "#BCBD22",
//     "Carbohydrates": "#393B79",
//     "Catalyst": "#5254A3",
//     "Cell Culture": "#6B6ECF",
//     "Chinese Pharmacopeia": "#4E79A7",
//     "Cylinders": "#9C9EDE",
//     "Dyes": "#637939",
//     "Enzyme": "#8CA252",
//     "EP Standards": "#B5CF6B",
//     "Equipment and Instruments": "#CEDB9C",
//     "Fine Chemicals": "#8C6D31",
//     "Fixed Assets": "#BD9E39",
//     "Food Grade": "#BD9E39",
//     "Gas Chromatography": "#E7BA52",
//     "GC Consumable": "#843C39",
//     "Glucuronides": "#E7BA52",
//     "High Purity Acids": "#843C39",
//     "HPLC configurations": "#AD494A",
//     "HPLC consumables": "#D6616B",
//     "Impurity": "#AD494A",
//     "Indian pharmacopoeia": "#D6616B",
//     "Instruments": "#E7969C",
//     "Intermediates": "#7B4173",
//     "Items": "#A55194",
//     "Kanto": "#CE6DBD",
//     "Lab Consumables": "#CE6DBD",
//     "Lab Systems & Fixtures": "#DE9ED6",
//     "Label": "#3182BD",
//     "Laboratory Containers & Storage": "#3182BD",
//     "Life science": "#6BAED6",
//     "Ligand": "#9ECAE1",
//     "Meatls&materials": "#E6550D",
//     "Membranes": "#6BAED6",
//     "Metabolites": "#9ECAE1",
//     "Metal Standard Solutions": "#E6550D",
//     "Multiple Pharmacopoeia": "#FD8D3C",
//     "Natural Products": "#FDAE6B",
//     "New Life Biologics": "#FDD0A2",
//     "Nitrosamine": "#31A354",
//     "NMR Solvents": "#74C476",
//     "Nucleosides and Nucleotides": "#A1D99B",
//     "Packaging Materials": "#C7E9C0",
//     "Peptides": "#756BB1",
//     "Pesticide Standards": "#9E9AC8",
//     "Polymer": "#BCBDDC",
//     "Reagent": "#DADAEB",
//     "Reference Materials": "#636363",
//     "Secondary Standards": "#969696",
//     "Services": "#BDBDBD",
//     "Solvent": "#D9D9D9",
//     "Stable Isotope reagents": "#8DD3C7",
//     "Stable isotopes": "#FFFFB3",
//     "Sustaintech": "#BEBADA",
//     "Trading": "#BEBADA",
//     "Ultrapur": "#FB8072",
//     "Ultrapur-100": "#80B1D3",
//     "USP Standards": "#FDB462",
//     "VOLAB": "#FD8D3C",
//     "Uncategorized": "#9ca3af"
// };

// const Category = () => {
//     const fyOptions = buildFYOptions();
//     const [financialYear, setFinancialYear] = useState(getCurrentFY());
//     const [activeFilters, setActiveFilters] = useState({});
//     const [chartData, setChartData] = useState(null);
//     const [userRole, setUserRole] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     // ─── Fetch ─────────────────────────────────────────────────
//     const fetchCategoryData = async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             // Take first value from comma-separated multi-select
//             const filtersToSend = {};
//             Object.entries(activeFilters).forEach(([key, val]) => {
//                 if (val) {
//                     const first = val.split(',')[0];
//                     if (first) filtersToSend[key] = first;
//                 }
//             });

//             const response = await categoryApi.getCategoryData(financialYear, filtersToSend);
//             const data = response?.data || response;
//             const roleId = response?.roleId;

//             setUserRole(roleId);
//             prepareChartData(data);
//         } catch (err) {
//             setError('Failed to load category data');
//             console.error('❌ Error:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchCategoryData();
//     }, [financialYear, activeFilters]);

//     // ─── Chart preparation ──────────────────────────────────────
//     const prepareChartData = (data) => {
//         if (!data || data.length === 0) {
//             setChartData(null);
//             return;
//         }

//         const months = [...new Set(data.map(item => item.month))];

//         const categories = [...new Set(data.map(item => item.category))]
//             .filter(category => {
//                 const totalSales = data
//                     .filter(d => d.category === category)
//                     .reduce((sum, d) => sum + (d.sales || 0), 0);
//                 return totalSales > 0;
//             });

//         const datasets = categories.map(category => {
//             const categoryData = months.map(month => {
//                 const found = data.find(d => d.month === month && d.category === category);
//                 return found ? found.sales : 0;
//             });

//             return {
//                 label: category,
//                 data: categoryData,
//                 backgroundColor: categoryColors[category] || '#9ca3af',
//                 borderColor: categoryColors[category] || '#9ca3af',
//                 borderWidth: 1
//             };
//         });

//         setChartData({ labels: months, datasets });
//     };

//     // ─── Stable filter callback ────────────────────────────────
//     const handleFiltersChange = useCallback((newFilters) => {
//         setActiveFilters(newFilters);
//     }, []);

//     const chartOptions = {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//             legend: { 
//                 position: 'bottom',
//                 align: 'center', 
//                 labels: {
//                     font: { size: 10 },
//                     boxWidth: 12,
//                     padding: 8
//                 }
//             },
//             tooltip: {
//                 mode: 'index',
//                 intersect: false,
//                 callbacks: {
//                     title: (tooltipItems) => {
//                         if (tooltipItems && tooltipItems.length > 0) {
//                             return tooltipItems[0].label;
//                         }
//                         return '';
//                     },
//                     label: (tooltipItem) => {
//                         const dataset = tooltipItem.dataset;
//                         const value = tooltipItem.raw;
//                         const label = dataset.label || '';
                        
//                         if (value === 0) return null;
                        
//                         // Calculate total for this data point across all categories
//                         let total = 0;
//                         if (tooltipItem.chart && tooltipItem.chart.data && tooltipItem.chart.data.datasets) {
//                             tooltipItem.chart.data.datasets.forEach(ds => {
//                                 total += ds.data[tooltipItem.dataIndex] || 0;
//                             });
//                         }
                        
//                         const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : 0;
//                         const formattedValue = '₹' + value.toLocaleString('en-IN', {
//                             minimumFractionDigits: 0,
//                             maximumFractionDigits: 0
//                         });
                        
//                         return `${label}: ${formattedValue} (${percentage}%)`;
//                     },
//                     afterLabel: () => '',
//                     footer: () => ''
//                 }
//             }
//         },
//         scales: {
//             x: {
//                 stacked: true,
//                 grid: { display: false },
//                 title: { 
//                     display: true, 
//                     text: 'Month', 
//                     font: { size: 12, weight: 'bold' } 
//                 }
//             },
//             y: {
//                 stacked: true,
//                 beginAtZero: true,
//                 grid: { color: '#e5e7eb' },
//                 title: { 
//                     display: true, 
//                     text: 'Sales Amount (₹)', 
//                     font: { size: 12, weight: 'bold' } 
//                 },
//                 ticks: {
//                     callback: (value) => {
//                         if (value >= 10000000) return '₹' + (value / 10000000).toFixed(1) + 'Cr';
//                         if (value >= 100000) return '₹' + (value / 100000).toFixed(1) + 'L';
//                         if (value >= 1000) return '₹' + (value / 1000).toFixed(0) + 'K';
//                         return '₹' + value;
//                     }
//                 }
//             }
//         },
//         interaction: { 
//             mode: 'index', 
//             intersect: false 
//         }
//     };

//     return (
//         <div className={styles.componentWrapper}>
//             <div className={styles.headerSection}>
//                 <h2 className={styles.componentTitle}>Category-wise Sales</h2>
//                 <div className={styles.fyDropdown}>
//                     <label>FY:</label>
//                     <select
//                         value={financialYear}
//                         onChange={(e) => setFinancialYear(e.target.value)}
//                         className={styles.select}
//                     >
//                         {fyOptions.map(fy => (
//                             <option key={fy} value={fy}>{fy}</option>
//                         ))}
//                     </select>
//                 </div>
//             </div>

//             {/* Same filters as SalesVsCogs */}
//             <SalesCogsFilters
//                 userRoleId={userRole}
//                 onFiltersChange={handleFiltersChange}
//             />

//             {error && <div className={styles.errorMessage}>{error}</div>}

//             {loading && (
//                 <div className={styles.loadingContainer}>
//                     <div className={styles.loadingSpinner} />
//                     <span>Loading chart data...</span>
//                 </div>
//             )}

//             {!loading && chartData && chartData.datasets && chartData.datasets.length > 0 && (
//                 <div className={styles.chartContainer}>
//                     <Bar data={chartData} options={chartOptions} />
//                 </div>
//             )}

//             {!loading && !chartData && !error && (
//                 <div className={styles.noDataMessage}>
//                     No category data available for FY {financialYear}
//                 </div>
//             )}
            
//             {!loading && chartData && chartData.datasets && chartData.datasets.length === 0 && (
//                 <div className={styles.noDataMessage}>
//                     No sales data available for the selected filters
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Category;


import React, { useState, useEffect, useCallback } from "react";
import styles from "./category.module.css";
import { categoryApi } from "../../../api/home/categoryApi";
import SalesCogsFilters from "./SalesCogsFilters/SalesCogsFilters";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// ─── Same FY helpers as SalesVsCogs ───────────────────────────────────────
const getCurrentFY = () => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    const startYear = month >= 4 ? year : year - 1;
    return `${startYear}-${String(startYear + 1).slice(2)}`;
};

const buildFYOptions = () => {
    const current = new Date().getFullYear();
    const options = [];
    for (let y = current; y >= 2022; y--) {
        options.push(`${y}-${String(y + 1).slice(2)}`);
    }
    return options;
};

const categoryColors = {
    "3A Chemicals": "#4E79A7",
    "Amino Acids": "#F28E2B",
    "Analytical Instruments": "#E15759",
    "Analytical Standards": "#76B7B2",
    "API": "#59A14F",
    "Assets": "#EDC948",
    "Biochemicals": "#B07AA1",
    "Biological Buffers": "#FF9DA7",
    "British Pharmacopoeia": "#9C755F",
    "Building Blocks": "#BAB0AC",
    "Cans": "#17BECF",
    "Capricorn": "#BCBD22",
    "Carbohydrates": "#393B79",
    "Catalyst": "#5254A3",
    "Cell Culture": "#6B6ECF",
    "Chinese Pharmacopeia": "#4E79A7",
    "Cylinders": "#9C9EDE",
    "Dyes": "#637939",
    "Enzyme": "#8CA252",
    "EP Standards": "#B5CF6B",
    "Equipment and Instruments": "#CEDB9C",
    "Fine Chemicals": "#8C6D31",
    "Fixed Assets": "#BD9E39",
    "Food Grade": "#BD9E39",
    "Gas Chromatography": "#E7BA52",
    "GC Consumable": "#843C39",
    "Glucuronides": "#E7BA52",
    "High Purity Acids": "#843C39",
    "HPLC configurations": "#AD494A",
    "HPLC consumables": "#D6616B",
    "Impurity": "#AD494A",
    "Indian pharmacopoeia": "#D6616B",
    "Instruments": "#E7969C",
    "Intermediates": "#7B4173",
    "Items": "#A55194",
    "Kanto": "#CE6DBD",
    "Lab Consumables": "#CE6DBD",
    "Lab Systems & Fixtures": "#DE9ED6",
    "Label": "#3182BD",
    "Laboratory Containers & Storage": "#3182BD",
    "Life science": "#6BAED6",
    "Ligand": "#9ECAE1",
    "Meatls&materials": "#E6550D",
    "Membranes": "#6BAED6",
    "Metabolites": "#9ECAE1",
    "Metal Standard Solutions": "#E6550D",
    "Multiple Pharmacopoeia": "#FD8D3C",
    "Natural Products": "#FDAE6B",
    "New Life Biologics": "#FDD0A2",
    "Nitrosamine": "#31A354",
    "NMR Solvents": "#74C476",
    "Nucleosides and Nucleotides": "#A1D99B",
    "Packaging Materials": "#C7E9C0",
    "Peptides": "#756BB1",
    "Pesticide Standards": "#9E9AC8",
    "Polymer": "#BCBDDC",
    "Reagent": "#DADAEB",
    "Reference Materials": "#636363",
    "Secondary Standards": "#969696",
    "Services": "#BDBDBD",
    "Solvent": "#D9D9D9",
    "Stable Isotope reagents": "#8DD3C7",
    "Stable isotopes": "#FFFFB3",
    "Sustaintech": "#BEBADA",
    "Trading": "#BEBADA",
    "Ultrapur": "#FB8072",
    "Ultrapur-100": "#80B1D3",
    "USP Standards": "#FDB462",
    "VOLAB": "#FD8D3C",
    "Uncategorized": "#9ca3af"
};

const Category = () => {
    const fyOptions = buildFYOptions();
    const [financialYear, setFinancialYear] = useState(getCurrentFY());
    const [activeFilters, setActiveFilters] = useState({});
    const [chartData, setChartData] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // ─── Fetch ─────────────────────────────────────────────────
    const fetchCategoryData = async () => {
        try {
            setLoading(true);
            setError(null);

            // Take first value from comma-separated multi-select
            const filtersToSend = {};
            Object.entries(activeFilters).forEach(([key, val]) => {
                if (val) {
                    const first = val.split(',')[0];
                    if (first) filtersToSend[key] = first;
                }
            });

            const response = await categoryApi.getCategoryData(financialYear, filtersToSend);
            const data = response?.data || response;
            const roleId = response?.roleId;

            setUserRole(roleId);
            prepareChartData(data);
        } catch (err) {
            setError('Failed to load category data');
            console.error('❌ Error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategoryData();
    }, [financialYear, activeFilters]);

    // ─── Chart preparation ──────────────────────────────────────
    const prepareChartData = (data) => {
        if (!data || data.length === 0) {
            setChartData(null);
            return;
        }

        const months = [...new Set(data.map(item => item.month))];
        
        // Calculate total sales for each category across all months
        const categoryTotals = {};
        data.forEach(item => {
            if (!categoryTotals[item.category]) {
                categoryTotals[item.category] = 0;
            }
            categoryTotals[item.category] += item.sales || 0;
        });
        
        // Sort categories by total sales (highest to lowest)
        const categories = Object.keys(categoryTotals)
            .filter(category => categoryTotals[category] > 0)
            .sort((a, b) => categoryTotals[b] - categoryTotals[a]);

        const datasets = categories.map(category => {
            const categoryData = months.map(month => {
                const found = data.find(d => d.month === month && d.category === category);
                return found ? found.sales : 0;
            });

            return {
                label: category,
                data: categoryData,
                backgroundColor: categoryColors[category] || '#9ca3af',
                borderColor: categoryColors[category] || '#9ca3af',
                borderWidth: 1
            };
        });

        setChartData({ labels: months, datasets });
    };

    // ─── Stable filter callback ────────────────────────────────
    const handleFiltersChange = useCallback((newFilters) => {
        setActiveFilters(newFilters);
    }, []);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { 
                position: 'bottom',
                align: 'center', 
                labels: {
                    font: { size: 10 },
                    boxWidth: 12,
                    padding: 8
                }
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    title: (tooltipItems) => {
                        if (tooltipItems && tooltipItems.length > 0) {
                            return tooltipItems[0].label;
                        }
                        return '';
                    },
                    beforeBody: (tooltipItems) => {
                        // Calculate total sales for this data point
                        let total = 0;
                        tooltipItems.forEach(item => {
                            total += item.raw;
                        });
                        const formattedTotal = '₹' + total.toLocaleString('en-IN', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        });
                        return `Total Sales: ${formattedTotal}`;
                    },
                    label: (tooltipItem) => {
                        const dataset = tooltipItem.dataset;
                        const value = tooltipItem.raw;
                        const label = dataset.label || '';
                        
                        if (value === 0) return null;
                        
                        // Calculate total for this data point across all categories
                        let total = 0;
                        if (tooltipItem.chart && tooltipItem.chart.data && tooltipItem.chart.data.datasets) {
                            tooltipItem.chart.data.datasets.forEach(ds => {
                                total += ds.data[tooltipItem.dataIndex] || 0;
                            });
                        }
                        
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : 0;
                        const formattedValue = '₹' + value.toLocaleString('en-IN', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        });
                        
                        return `${label}: ${formattedValue} (${percentage}%)`;
                    },
                    afterBody: () => '',
                    footer: () => ''
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: { display: false },
                title: { 
                    display: true, 
                    text: 'Month', 
                    font: { size: 12, weight: 'bold' } 
                }
            },
            y: {
                stacked: true,
                beginAtZero: true,
                grid: { color: '#e5e7eb' },
                title: { 
                    display: true, 
                    text: 'Sales Amount (₹)', 
                    font: { size: 12, weight: 'bold' } 
                },
                ticks: {
                    callback: (value) => {
                        if (value >= 10000000) return '₹' + (value / 10000000).toFixed(1) + 'Cr';
                        if (value >= 100000) return '₹' + (value / 100000).toFixed(1) + 'L';
                        if (value >= 1000) return '₹' + (value / 1000).toFixed(0) + 'K';
                        return '₹' + value;
                    }
                }
            }
        },
        interaction: { 
            mode: 'index', 
            intersect: false 
        }
    };

    return (
        <div className={styles.componentWrapper}>
            <div className={styles.headerSection}>
                <h2 className={styles.componentTitle}>Category-wise Sales</h2>
                <div className={styles.fyDropdown}>
                    <label>FY:</label>
                    <select
                        value={financialYear}
                        onChange={(e) => setFinancialYear(e.target.value)}
                        className={styles.select}
                    >
                        {fyOptions.map(fy => (
                            <option key={fy} value={fy}>{fy}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Same filters as SalesVsCogs */}
            <SalesCogsFilters
                userRoleId={userRole}
                onFiltersChange={handleFiltersChange}
            />

            {error && <div className={styles.errorMessage}>{error}</div>}

            {loading && (
                <div className={styles.loadingContainer}>
                    <div className={styles.loadingSpinner} />
                    <span>Loading chart data...</span>
                </div>
            )}

            {!loading && chartData && chartData.datasets && chartData.datasets.length > 0 && (
                <div className={styles.chartContainer}>
                    <Bar data={chartData} options={chartOptions} />
                </div>
            )}

            {!loading && !chartData && !error && (
                <div className={styles.noDataMessage}>
                    No category data available for FY {financialYear}
                </div>
            )}
            
            {!loading && chartData && chartData.datasets && chartData.datasets.length === 0 && (
                <div className={styles.noDataMessage}>
                    No sales data available for the selected filters
                </div>
            )}
        </div>
    );
};

export default Category;